// Products data for EidGeschenke.de

// Placeholder image for coming soon products
const PLACEHOLDER_IMAGE = 'data:image/svg+xml,' + encodeURIComponent(`
<svg width="400" height="300" xmlns="http://www.w3.org/2000/svg">
  <rect width="100%" height="100%" fill="#F5F5F0"/>
  <text x="50%" y="45%" font-family="system-ui, sans-serif" font-size="18" fill="#9CA3AF" text-anchor="middle">Bald verfügbar</text>
  <text x="50%" y="55%" font-family="system-ui, sans-serif" font-size="14" fill="#D4C5A9" text-anchor="middle">Coming Soon</text>
</svg>
`);

export const products = [
  // Family gifts
  {
    id: 'fam-1',
    name: 'SIRA Quiz - Leben des Propheten',
    description: '52 hochwertige Quizkarten über das Leben des Propheten Muhammed (s.a.s.). Perfekt für Familie und Freunde – ideal als Ramadan oder Eid Geschenk!',
    price: '13,80 €',
    image: 'https://customer-assets.emergentagent.com/job_580427b5-ca5e-4a1e-be7f-809d67988bcf/artifacts/j3w5z1f9_image.png',
    category: 'Familien',
    categorySlug: 'familien',
    featured: true,
    affiliateLink: 'https://amzn.to/4al0oCu',
  },
  {
    id: 'fam-2',
    name: 'Eid Geschenkbox für Familien',
    description: 'Eine liebevoll zusammengestellte Box mit hochwertigen Süßigkeiten und Dekorationsartikeln für das gemeinsame Eid-Fest.',
    price: '49,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Familien',
    categorySlug: 'familien',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'fam-3',
    name: 'Premium Datteln Kollektion',
    description: 'Exquisite Datteln aus verschiedenen Regionen, elegant verpackt als traditionelles Eid-Geschenk.',
    price: '34,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Familien',
    categorySlug: 'familien',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'fam-4',
    name: 'Festliches Tee-Set',
    description: 'Hochwertiges Tee-Set mit orientalischen Gläsern und einer Auswahl feiner Teesorten.',
    price: '59,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Familien',
    categorySlug: 'familien',
    featured: false,
    affiliateLink: '#',
  },

  // Kids gifts
  {
    id: 'kid-1',
    name: 'Mama, was ist Ramadan?',
    description: 'Ein liebevolles Kinderbuch, das Fragen über Ramadan und Islam kindgerecht beantwortet. Für Kinder von 3-8 Jahren. 72 Seiten voller lehrreicher Geschichten über Fasten, Geduld, Barmherzigkeit und Nächstenliebe.',
    price: '14,99 €',
    image: 'https://customer-assets.emergentagent.com/job_580427b5-ca5e-4a1e-be7f-809d67988bcf/artifacts/tyhofq4q_image.png',
    category: 'Kinder',
    categorySlug: 'kinder',
    featured: true,
    affiliateLink: 'https://amzn.to/3MtLbac',
  },
  {
    id: 'kid-2',
    name: 'Kreativ-Set für kleine Künstler',
    description: 'Malstifte, Bastelpapier und Anleitungen für Eid-inspirierte Kunstprojekte.',
    price: '24,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Kinder',
    categorySlug: 'kinder',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'kid-3',
    name: 'Eid Überraschungsbox für Kinder',
    description: 'Bunte Box gefüllt mit altersgerechtem Spielzeug, Süßigkeiten und einer kleinen Eid-Karte.',
    price: '29,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Kinder',
    categorySlug: 'kinder',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'kid-4',
    name: 'Mollis Plüschtier-Schaf (36 cm)',
    description: 'Weiches Kuscheltier-Schaf aus Schweden – perfekt für Eid ul Adha! Hochwertiges Stofftier für Kinder und Babys, ideal zum Kuscheln und als symbolisches Eid-Geschenk.',
    price: '25,90 €',
    image: 'https://customer-assets.emergentagent.com/job_eidschenke/artifacts/ao24p6n9_image.png',
    category: 'Kinder',
    categorySlug: 'kinder',
    featured: true,
    affiliateLink: 'https://amzn.to/4kxMYrs',
  },

  // Women gifts
  {
    id: 'wom-1',
    name: 'Swiss Arabian Parfum Geschenkset',
    description: 'Luxuriöses Parfumset mit orientalischen Düften – ein elegantes Geschenk für besondere Anlässe wie Eid.',
    price: '60,00 €',
    image: 'https://customer-assets.emergentagent.com/job_580427b5-ca5e-4a1e-be7f-809d67988bcf/artifacts/g6czt7wl_image.png',
    category: 'Frauen',
    categorySlug: 'frauen',
    featured: true,
    affiliateLink: 'https://amzn.to/4r2XFVd',
  },
  {
    id: 'wom-2',
    name: 'RITUALS Velvet Oudh Geschenkset',
    description: 'Vier luxuriöse Produkte für Bad, Körper und Raumduft – mit dem betörenden Duft von Oud und orientalischen Noten.',
    price: '69,90 €',
    image: 'https://customer-assets.emergentagent.com/job_eidschenke/artifacts/0kpdcfu6_image.png',
    category: 'Frauen',
    categorySlug: 'frauen',
    featured: true,
    affiliateLink: 'https://amzn.to/4rFriw0',
  },
  {
    id: 'wom-3',
    name: 'Goldkette mit Anhänger',
    description: 'Elegante Goldkette mit filigranem Anhänger – ein zeitloser Klassiker.',
    price: '39,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Frauen',
    categorySlug: 'frauen',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'wom-4',
    name: 'Duftkerzen-Set',
    description: 'Drei handgefertigte Duftkerzen mit orientalischen Düften wie Oud, Amber und Rose.',
    price: '32,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Frauen',
    categorySlug: 'frauen',
    featured: false,
    affiliateLink: '#',
  },

  // Men gifts
  {
    id: 'man-1',
    name: 'Swiss Arabian Parfum Geschenkset',
    description: 'Luxuriöses Parfumset mit orientalischen Düften – ein elegantes Geschenk für besondere Anlässe wie Eid.',
    price: '60,00 €',
    image: 'https://customer-assets.emergentagent.com/job_580427b5-ca5e-4a1e-be7f-809d67988bcf/artifacts/g6czt7wl_image.png',
    category: 'Männer',
    categorySlug: 'maenner',
    featured: true,
    affiliateLink: 'https://amzn.to/4r2XFVd',
  },
  {
    id: 'man-2',
    name: 'RITUALS Velvet Oudh Geschenkset',
    description: 'Vier luxuriöse Produkte für Bad, Körper und Raumduft – mit dem betörenden Duft von Oud und orientalischen Noten.',
    price: '69,90 €',
    image: 'https://customer-assets.emergentagent.com/job_eidschenke/artifacts/0kpdcfu6_image.png',
    category: 'Männer',
    categorySlug: 'maenner',
    featured: true,
    affiliateLink: 'https://amzn.to/4rFriw0',
  },
  {
    id: 'man-3',
    name: 'Hochwertige Armbanduhr',
    description: 'Klassische Armbanduhr mit elegantem Design – zeitlos und stilvoll.',
    price: '89,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Männer',
    categorySlug: 'maenner',
    featured: false,
    affiliateLink: '#',
  },
  {
    id: 'man-4',
    name: 'Gebetsset für Herren',
    description: 'Hochwertiger Gebetsteppich mit passendem Zubehör in einer eleganten Box.',
    price: '44,99 €',
    image: PLACEHOLDER_IMAGE,
    category: 'Männer',
    categorySlug: 'maenner',
    featured: false,
    affiliateLink: '#',
  },
];

// Eid ul Fitr specific products - only real products
export const eidFitrProducts = [
  products[0], // SIRA Quiz
  products[4], // Mama, was ist Ramadan?
];

// Eid ul Adha specific products - only real products
export const eidAdhaProducts = [
  products[0], // SIRA Quiz
  products[4], // Mama, was ist Ramadan?
  products[7], // Mollis Plüschtier-Schaf
];

// Get products by category
export const getProductsByCategory = (categorySlug) => {
  return products.filter(p => p.categorySlug === categorySlug);
};

// Get featured products (only real ones, unique by name)
export const getFeaturedProducts = () => {
  const featured = products.filter(p => p.featured && p.affiliateLink !== '#');
  // Remove duplicates by name - keep only the first occurrence
  const uniqueByName = [];
  const seenNames = new Set();
  for (const product of featured) {
    if (!seenNames.has(product.name)) {
      seenNames.add(product.name);
      uniqueByName.push(product);
    }
  }
  return uniqueByName;
};

// Categories data
export const categories = [
  {
    id: 'familien',
    name: 'Für Familien',
    description: 'Handverlesene Geschenkideen für gemeinsame Momente zu Eid. Von klassischen Süßigkeiten-Körben bis zu besonderen Eid Geschenken für die ganze Familie.',
    productCount: 4,
  },
  {
    id: 'kinder',
    name: 'Für Kinder',
    description: 'Kleine Überraschungen, die Kinderaugen zu Eid zum Leuchten bringen. Entdecke liebevoll ausgewählte Eid Mubarak Geschenke für Kinder jeden Alters.',
    productCount: 4,
  },
  {
    id: 'frauen',
    name: 'Für Frauen',
    description: 'Stilvolle und besondere Geschenkideen für Frauen. Von Parfum-Sets bis zu Accessoires – finde das perfekte Eid Geschenk für sie.',
    productCount: 4,
  },
  {
    id: 'maenner',
    name: 'Für Männer',
    description: 'Zeitlose und praktische Geschenkideen für Männer. Von Duftölen bis Gebetsketten – die schönsten Eid Geschenke für ihn.',
    productCount: 4,
  },
];
